var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShButton',{class:_vm.classes,attrs:{"title":_vm.label,"type":"button"},on:{"click":function($event){_vm.$emit('click', $event)}}},[_c('FontAwesomeIcon',{attrs:{"icon":['fal', 'times'],"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }